'use client';

import { Box, Typography, Button } from '@mui/material';
import Link from 'next/link';

export default function NotFound() {
  return (
    <Box
      sx={{
        height: '80vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        px: 2
      }}
    >
      <Typography variant="h2" gutterBottom sx={{ fontWeight: 700 }}>
        404
      </Typography>
      <Typography variant="h5" color="text.secondary" gutterBottom>
        La página que buscas no existe.
      </Typography>
      <Link href="/">
        <Button variant="contained" color="primary">
          Volver al inicio
        </Button>
      </Link>
    </Box>
  );
}
